import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import './index.css';
import './pages/sop/sopSwal.css';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import AppShell from './components/AppShell/AppShell';
import RequireAuth from './components/RequireAuth';
import LoginPage from './pages/login/LoginPage';
import RulesPage from './pages/sop/RulesPage';
import GamePage from './pages/sop/GamePage';
import ThankYouPage from './pages/sop/ThankYouPage';
import LeaderboardPage from './pages/sop/LeaderboardPage';

function App() {
  return (
    <Provider store={store}>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/intro" element={<Navigate to="/" replace />} />

        <Route
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        >
          <Route path="/rules" element={<RulesPage />} />
          <Route path="/game" element={<GamePage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/leaderboard" element={<LeaderboardPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

reportWebVitals();
